import { ConversionBlock } from '@/entities/conversion'
import { BaseCard } from '@/shared/components'
import { BaseProgressBar } from '@/shared/components/BaseProgressBar/BaseProgressBar'
import { TradersIcon } from '@/shared/components/icons/TradersIcon'
import { ReferralModel } from '@/entities/referral/model/types'
import { formatCurrency } from '@/shared/lib/currency'
import { Currencies } from '@/entities/curency'
import { Link } from 'react-router-dom'

type Props = {
  referral: ReferralModel
}

export const ReferralMobileBlock = ({ referral }: Props) => {
  return (
    <div className="w-full mb-4 last:mb-0 md:hidden">
      <Link to={`/referrals/${referral.id}`} className="w-full no-underline">
        <BaseCard className="px-5 text-sm">
        <div className="flex justify-between pb-4">
          <div className="flex gap-3">
            <TradersIcon status={referral.status} />
            <div className="flex flex-col">
              <span className="font-medium">{referral.username}</span>
              <span className="text-text-secondary text-sm">ID: {referral.id}</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-y-2 pb-4">
          <span className="text-text-secondary">Суточный лимит</span>
          <BaseProgressBar variant="table" currentBalance={referral.dailyLimit} totalBalance={referral.totalRequisitMaxDailyLimit || 1000000} />
        </div>
        <div className="flex flex-col gap-y-2 pb-4">
          <span className="text-text-secondary">Конверсия</span>
          <ConversionBlock current={referral.conversion.current} goal={referral.conversion.goal} />
        </div>

        <div className="flex flex-col gap-y-2">
          <span className="text-text-secondary">Личная прибыль</span>
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-klein font-medium text-sm">{formatCurrency(referral.personalProfit, Currencies.USDT)}</span>
          </div>
        </div>
      </BaseCard>
      </Link>
    </div>
  )
}
